import React from 'react';

export default props => (
  <svg {...props} width={148} height={119} fill="none" viewBox="0 0 148 119">
    <path
      d="M70.3 117.939c28 0 50.7-22.7 50.7-50.8 0-28.1-22.8-50.8-50.7-50.8-28 0-50.7 22.7-50.7 50.8 0 28.1 22.7 50.8 50.7 50.8z"
      fill="#F1F3F9"
      stroke="#D6DCE8"
      strokeWidth={2}
      strokeMiterlimit={10}
    />
    <path
      d="M117.7 33.839a4.1 4.1 0 100-8.2 4.1 4.1 0 000 8.2zM123.7 17.838a2.8 2.8 0 100-5.599 2.8 2.8 0 000 5.6z"
      fill="#F1F3F9"
    />
    <path d="M22.3 33.739a2.8 2.8 0 100-5.6 2.8 2.8 0 000 5.6z" fill="#EAEEF9" />
    <path d="M5.2 87.738a5.2 5.2 0 100-10.4 5.2 5.2 0 000 10.4z" fill="#F1F3F9" />
    <path
      d="M147.569 51.189h-4.961v-4.962h-4.252v4.962h-4.961v4.394h4.961v4.961h4.252v-4.961h4.961v-4.394zM65.469 4.241h-4.241V0h-3.635v4.241h-4.241v3.756h4.24v4.242h3.636V7.997h4.24V4.241zM15.552 46.553H11.93v-3.624H8.823v3.624H5.199v3.21h3.624v3.623h3.106v-3.624h3.623v-3.21z"
      fill="#AAB2C5"
    />
    <path
      d="M105.963 57.342L95.95 32.89c-1.786-4.347-6.443-6.83-11.023-5.822l-25.849 5.59c-2.173.465-4.036 1.94-5.123 3.88L29.348 83.425c-1.009 1.94-.31 4.424 1.708 5.433L75.612 112.3c1.94 1.009 4.425.31 5.434-1.708l24.607-46.885c1.086-1.94 1.164-4.27.31-6.365zm-24.762-9.858c-3.182-1.63-4.424-5.59-2.717-8.772 1.63-3.182 5.59-4.424 8.772-2.717 3.182 1.63 4.424 5.59 2.717 8.772-1.63 3.182-5.59 4.424-8.772 2.717z"
      fill="#fff"
      stroke="#D6DCE8"
      strokeWidth={2}
      strokeMiterlimit={10}
    />
    <path
      d="M84.384 41.507c20.26-10.48 28.255-26.082 17.698-32.835-10.557-6.754-20.958 0-23.598 19.639"
      stroke="#AAB2C5"
      strokeWidth={5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M97 118c13.254 0 24-10.724 24-24s-10.793-24-24-24c-13.254 0-24 10.724-24 24s10.746 24 24 24z"
      fill="#F1F3F9"
      stroke="#D6DCE8"
      strokeWidth={2}
      strokeMiterlimit={10}
    />
    <path
      d="M91.37 108a2.717 2.717 0 01-1.991-.842l-9.567-9.793c-1.083-1.108-1.083-2.969 0-4.076a2.802 2.802 0 013.982 0l7.576 7.754 17.836-18.212a2.801 2.801 0 013.982 0c1.083 1.108 1.083 2.969 0 4.076l-19.826 20.251c-.52.576-1.256.842-1.992.842z"
      fill="#fff"
      stroke="#D6DCE8"
      strokeWidth={2}
      strokeMiterlimit={10}
    />
    <path
      d="M80.122 74.893c1.37.759 3.195.234 3.954-1.136.759-1.37.234-3.196-1.136-3.954-1.37-.76-3.196-.235-3.954 1.136-.813 1.468-.333 3.141 1.136 3.954zM63.699 68.658l1.267.715c-.25 2.944 2.08 5.417 4.982 5.514a4.8 4.8 0 003.201-.89l1.267.715c-2.778 2.415-7.166 1.992-9.428-.828-1.034-1.355-1.64-3.24-1.289-5.226zM60.544 64.055c1.37.758 3.195.234 3.954-1.137.759-1.37.234-3.195-1.136-3.954-1.37-.759-3.196-.234-3.955 1.136-.715 1.523-.234 3.196 1.137 3.955z"
      fill="#AAB2C5"
    />
  </svg>
);
